<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-12">
    <label
      v-if="canUseGooglePay"
      class="cf-card cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-10"
      for="google-pay"
    >
      <div class="cf-checkbox-input cf-checkbox-input--radio cf-checkbox-input--default cf-checkbox-input--no-label-text">
        <div class="cf-checkbox-input__option">
          <input
            id="google-pay"
            v-model="localSelectedPaymentMethod"
            class="cf-checkbox-input__input"
            type="radio"
            name="selectedCard"
            value="GooglePay"
          >

          <div class="cf-checkbox-input__label" />
        </div>
      </div>

      <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-8">
        <cf-card-type-icon payment-type="GooglePay" />

        <h4 class="cf-title cf-title--4">
          Google Pay
        </h4>
      </div>
    </label>

    <template v-if="canUseApplePay || forceShowApplePay">
      <label
        class="cf-card cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-10"
        for="apple-pay"
      >
        <div class="cf-checkbox-input cf-checkbox-input--radio cf-checkbox-input--default cf-checkbox-input--no-label-text">
          <div class="cf-checkbox-input__option">
            <input
              id="apple-pay"
              v-model="localSelectedPaymentMethod"
              class="cf-checkbox-input__input"
              type="radio"
              name="selectedCard"
              value="ApplePay"
            >

            <div class="cf-checkbox-input__label" />
          </div>
        </div>

        <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-8">
          <cf-card-type-icon payment-type="ApplePay" />

          <h4 class="cf-title cf-title--4">
            Apple Pay
          </h4>
        </div>
      </label>

      <transition name="fade-down-only-in">
        <div
          v-if="!canUseApplePay && selectedPaymentMethod === 'ApplePay'"
          class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-center cf-flex--gap-10 cf-alt-background"
        >
          <span class="cf-icon cf-icon--red far fa-exclamation-circle" />

          <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
            Apple Pay Auto Reload payment methods can only be configured in the Safari browser or with an iOS device.
          </p>
        </div>

      </transition>
    </template>
  </div>
</template>


<script>
  import CfCardTypeIcon from '@/view/components/shared/cf-card-type-icon/index.vue';


  export default {
    name: 'CfAltPaymentButtons',

    components: {
      CfCardTypeIcon
    },

    props: {
      canUseGooglePay: {
        type: Boolean,
        default: false
      },

      canUseApplePay: {
        type: Boolean,
        default: false
      },

      forceShowApplePay: {
        type: Boolean,
        default: false
      },

      selectedPaymentMethod: {
        type: String,
        default: null
      }
    },

    computed: {
      localSelectedPaymentMethod: {
        get() {
          return this.selectedPaymentMethod;
        },
        set(val) {
          this.$emit('method-select', val);
        }
      }
    }
  };
</script>
